import { SortDirection } from '@flatfile/api'
import { ESortOptions } from '@flatfile/turntable'
import { useState } from 'react'

import { useMemo } from 'react'

const useColumnContextMenu = ({
  column,
  isPinned,
  togglePinnedColumn,
  openSearchValueModal,
  openFindAndReplaceModal,
  getJobQuery,
}: any) => {
  const [isOpen, setIsOpen] = useState(false)

  const searchFields = {
    sortField: '',
    sortDirection: SortDirection.Asc,
  } as {
    sortField: string
    sortDirection: SortDirection
  }

  const columnSortOrder = useMemo(() => {
    return searchFields.sortField === column.value
      ? searchFields.sortDirection
      : ESortOptions.noOrder
  }, [searchFields.sortField, searchFields.sortDirection, column.value])

  const isAscending = columnSortOrder === SortDirection.Asc
  const isDescending = columnSortOrder === SortDirection.Desc

  const tSortAscending = isAscending
    ? 'sheet.table.contextMenu.sort.ascending.remove'
    : 'sheet.table.contextMenu.sort.ascending.apply'
  const tSortDescending = isDescending
    ? 'sheet.table.contextMenu.sort.descending.remove'
    : 'sheet.table.contextMenu.sort.descending.apply'
  const tPinColumn = isPinned
    ? 'sheet.table.contextMenu.pin.remove'
    : 'sheet.table.contextMenu.pin.apply'

  const {
    filterOptions,
    onPinSelected,
    onSortAscendingSelected,
    onSortDescendingSelected,
    onSearchByValueSelected,
    onReplaceEmptyCellsSelected,
    onFilterByValueOpenChange,
    onFilterByValueClose,
    onRoutineSelected,
    selectedFilterOptions,
    setSelectedFilterOptions,
    fetchingFilterOptions,
    filterSearchValue,
    onFilterSearchValueChange,
    onFindAndReplaceSelected,
  } = {
    tSortAscending: 'sheet.table.contextMenu.sortAscending',
    tSortDescending: 'sheet.table.contextMenu.sortDescending',
    tPinColumn: 'sheet.table.contextMenu.pinColumn',
    filterOptions: [],
    onPinSelected: () => {},
    onSortAscendingSelected: () => {},
    onSortDescendingSelected: () => {},
  } as any

  return {
    isOpen,
    setIsOpen,
    tSortAscending,
    tSortDescending,
    tPinColumn,
    filterOptions,
    onPinSelected,
    onSortAscendingSelected,
    onSortDescendingSelected,
    onSearchByValueSelected,
    onReplaceEmptyCellsSelected,
    onFilterByValueOpenChange,
    onFilterByValueClose,
    onRoutineSelected,
    selectedFilterOptions,
    setSelectedFilterOptions,
    fetchingFilterOptions,
    filterSearchValue,
    onFilterSearchValueChange,
    onFindAndReplaceSelected,
  }
}

export default useColumnContextMenu
